import React, { useState } from 'react';
import useGameStore from '../../store/gameStore';
import './AutoBetPanel.css';

export default function AutoBetPanel({ startAutoBet, stopAutoBet }) {
  const { autoBet, autoBetRemaining, betAmount } = useGameStore();
  const [count,      setCount]      = useState(10);
  const [stopStep,   setStopStep]   = useState(3);
  const [stopOnWin,  setStopOnWin]  = useState(false);
  const [stopOnLoss, setStopOnLoss] = useState(false);

  const countValid    = Number.isInteger(count)    && count    >= 1;
  const stopStepValid = Number.isInteger(stopStep) && stopStep >= 1;
  const canStart      = countValid && stopStepValid && betAmount >= 0.1;

  function handleStart() {
    if (!canStart) return;
    startAutoBet({ count, stopStep, stopOnWin, stopOnLoss });
  }

  return (
    <div className="auto-bet-panel anim-slide-up">
      <div className="ab-row">
        <label>Rounds</label>
        <input type="number" min="1" max="1000" value={count}
          onChange={e => setCount(parseInt(e.target.value, 10))} disabled={autoBet} />
      </div>
      <div className="ab-row">
        <label>Cash out on step</label>
        <input type="number" min="1" max="10" value={stopStep}
          onChange={e => setStopStep(parseInt(e.target.value, 10))} disabled={autoBet} />
      </div>
      <div className="ab-check-row">
        <label><input type="checkbox" checked={stopOnWin}
          onChange={e => setStopOnWin(e.target.checked)} disabled={autoBet} /> Stop on Win</label>
        <label><input type="checkbox" checked={stopOnLoss}
          onChange={e => setStopOnLoss(e.target.checked)} disabled={autoBet} /> Stop on Loss</label>
      </div>
      {autoBet ? (
        <div className="ab-status">
          <span>🤖 Running… {autoBetRemaining} rounds left</span>
          <button className="ab-stop-btn" onClick={stopAutoBet}>⏹ Stop</button>
        </div>
      ) : (
        <button className="ab-start-btn" onClick={handleStart} disabled={!canStart}>▶ Start Auto Bet</button>
      )}
    </div>
  );
}
